/**
 * @generated SignedSource<<d25f771d3967ed695dbaa0304dce52de>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type EditAwardPacPointsConfigurationForm_AwardPacPointsFragment$data = {
  readonly amount: number;
  readonly id: string;
  readonly " $fragmentType": "EditAwardPacPointsConfigurationForm_AwardPacPointsFragment";
};
export type EditAwardPacPointsConfigurationForm_AwardPacPointsFragment$key = {
  readonly " $data"?: EditAwardPacPointsConfigurationForm_AwardPacPointsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"EditAwardPacPointsConfigurationForm_AwardPacPointsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditAwardPacPointsConfigurationForm_AwardPacPointsFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "amount",
      "storageKey": null
    }
  ],
  "type": "AwardPacPointsRewardConfiguration",
  "abstractKey": null
};

(node as any).hash = "f00c6bb239ff90e748205e08e0d80b40";

export default node;
